<template>

    <div class="flex w-full gap-4 grow">
        <div class="flex flex-col gap-5 grow">
            <div class="md:py-7 max-md:pt-7 max-md:pb-2">
                <p class="text-3xl">{{ $t('dashboard.welcome', { name: $page.props.user.salutation }) }}</p>
            </div>

            <div class="flex justify-center gap-5">

                <div class="w-full">
                    <div
                        class="bg-white/50 dark:bg-black/20 rounded-3xl overflow-hidden flex flex-col justify-end relative pt-12 shadow-2xl shadow-slate-200 dark:shadow-none"
                        id="main-analytics">
                        <div class="absolute top-5 left-5">
                            <div class="text-lg mb-2 flex gap-3 items-center justify-center">
                                <span class="pi pi-calendar bg-gray-200 dark:bg-gray-700 p-3 rounded-lg"></span>
                                <div class="mt-1" style="line-height: 1.25rem">{{ $t('dashboard.reservations_two_weeks') }}</div>
                            </div>
                        </div>
                        <div class="absolute top-5 right-5 text-right">
                            <p class="text-sm text-gray-600 dark:text-gray-200">{{ $t('dashboard.widget_heatmap_sub') }} <span class="text-blue-600 mr-1">●</span></p>
                            <p class="text-sm text-gray-600 dark:text-gray-200">{{ $t('dashboard.last_week') }} <span class="text-blue-200 mr-1">●</span></p>
                        </div>
                        <dashboard-chart class="w-full"
                                         style="margin: -3px; width: calc(100% + 6px);"></dashboard-chart>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="false" class="w-2/6 flex flex-col border-l">
            <div v-if="false" class="bg-roori-bg bg-no-repeat bg-bottom bg-cover bg-si h-1/2 rounded-t-2xl"></div>
        </div>
    </div>
</template>
<script setup>
import {ref} from "vue";
import {router, usePage} from "@inertiajs/vue3";
import DashboardChart from "../components/ui-components/dashboard/DashboardChart.vue";
import Button from "primevue/button";
import RequestItem from "../components/ui-components/dashboard/RequestItem.vue";
import RequestItems from "../components/ui-components/dashboard/RequestItems.vue";
import Reservations from "../components/ui-components/dashboard/Reservations.vue";

const chartData = ref({
    labels: usePage().props.analytics.weekDays,
    datasets: [
        {
            backgroundColor: '',
            borderColor: 'transparent',
            pointBackgroundColor: '#FFFFFF',
            pointBorderColor: '#FFFFFF',
            lineTension: 0.40,
            data: usePage().props.analytics.daysReservations,
            fill: true,
            tension: 0.7,
        }
    ]
})
</script>
